/* Coat & Clover - scroll reveals + micro-interactions.
   Progressive enhancement only: no motion when prefers-reduced-motion. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTORS = [
    '.cc-card', '.cc-step', '.cc-coat', '.cc-rung', '.cc-review',
    '.cc-outcome', '.cc-part', '.cc-compare__col', '.cc-closer',
    '.cc-hero__copy', '.cc-hero__media',
  ];

  var els = document.querySelectorAll(SELECTORS.join(','));
  if (!('IntersectionObserver' in window) || !els.length) return;

  els.forEach(function (el) {
    el.classList.add('cc-reveal');
    var parent = el.parentElement;
    if (parent) {
      var siblings = Array.prototype.filter.call(
        parent.children,
        function (c) { return c.classList.contains('cc-reveal'); }
      );
      var i = siblings.indexOf(el);
      if (i > 0) el.style.transitionDelay = Math.min(i * 90, 450) + 'ms';
    }
  });

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cc-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  els.forEach(function (el) { io.observe(el); });

  // Failsafe: content must never stay hidden if the observer misbehaves
  // (backgrounded tabs, exotic embeds). Reveal anything still pending.
  setTimeout(function () {
    els.forEach(function (el) {
      if (!el.classList.contains('cc-in')) {
        var r = el.getBoundingClientRect();
        if (r.top < (window.innerHeight || 800) * 1.3) el.classList.add('cc-in');
      }
    });
  }, 1500);
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('cc-in'); });
  }, 5000);
})();
